import src from "IMAGE";
export default { src, width: 959, height: 202, blurWidth: 0, blurHeight: 0};
